import { render, staticRenderFns } from "./markdown-wysiwyg.vue?vue&type=template&id=18b415cf&scoped=true&"
import script from "./markdown-wysiwyg.vue?vue&type=script&lang=js&"
export * from "./markdown-wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./markdown-wysiwyg.vue?vue&type=style&index=0&id=18b415cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b415cf",
  null
  
)

export default component.exports